/* src/app/forms/translate-form/translate-form.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;
  --mat-table-row-item-container-height: 80px;
  --mat-toolbar-standard-height: 80px;
}
table {
  width: 100%;
  display: block;
  position: relative;
}
.mat-mdc-form-field {
  font-size: 14px;
  width: 100%;
}
td,
th {
  width: 25%;
}
.col-center {
  text-align: center;
  justify-items: center;
}
.table-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.button-flex-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.table-container-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}
.button-container {
  display: flex;
  justify-content: center;
}
.main-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  gap: 10px;
  border-radius: 16px;
  border: 1px solid var(--tem-border);
  background-color: var(--tem-surface-2);
  box-shadow: 0px 0px 10px 0px var(--tem-surface-2);
}
.buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  gap: 10px;
}
.no-data-row {
  text-align: center;
  width: 100%;
  align-content: center;
  padding-top: 20px;
  font-weight: bold;
  font-size: 140%;
}
/*# sourceMappingURL=translate-form.component.css.map */
